var _path, _path2, _path3, _path4, _path5, _path6;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgGrammarMobile(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 295,
    height: 66,
    viewBox: "0 0 295 66",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M99 47.1624C81.1743 46.7499 79.2955 20.1208 99 18.8833V0C56.246 1.32916 53.7715 63.5249 99 65.9999V47.1624Z",
    fill: "#FFCC00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M198.523 47.1624C180.698 46.7499 178.819 20.1208 198.523 18.8833V0C155.769 1.32916 153.295 63.5249 198.523 65.9999V47.1624Z",
    fill: "#082C4E"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.19617e-05 0C42.754 1.32916 45.2285 63.5249 4.19617e-05 65.9999V0Z",
    fill: "#3098F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M165 66C122.246 64.6916 119.771 3.46766 165 1.03133V66Z",
    fill: "#FE6571"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M262.004 66C219.25 64.6708 216.775 2.47509 262.004 9.15527e-05V66Z",
    fill: "#FE6571"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M262 2.88495e-06C304.754 1.32916 307.229 63.5249 262 65.9999L262 2.88495e-06Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGrammarMobile);
export default __webpack_public_path__ + "static/media/grammar-mobile.21df7fb60e9ae872c100a77efa9fdea7.svg";
export { ForwardRef as ReactComponent };